import React from 'react';
import PropTypes from 'prop-types';
import Swiper from 'swiper';
import mapNodes from 'helpers/mapNodes';
import styled from 'styled-components';
import Link from 'gatsby-link';
import { media, theme } from 'styles';
import { sizes } from 'styles/media';
import { IconArrowRight } from 'icons';
import SwipeableCaseStudy from './SwipeableCaseStudy';

const Wrapper = styled.div`
  position: relative;
  height: 640px;
`;

const SwiperContainer = styled.div`
  margin: 0 20px;
  padding: 0 29px 50px;

  ${media.laptop`
    margin: 0 auto;
  `};
`;

const SwipeableCaseStudyWrapper = styled(Link)`
  text-decoration: none;

  ${media.tablet`
    width: calc((100% - ${parseInt(theme.sp.xl, 10)}px) / 2);
  `};
`;

const SwiperButtonNext = styled.div`
  top: 46.3%;
  left: auto;
  right: 22px;

  ${media.laptop`
    right: 3px;
  `};

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 25px;
  width: 50px;
  height: 50px;

  color: white;
  background-image: none;
  background: ${theme.colors.royal};

  &:focus {
    outline: none;
  }
`;

// I don't have a left arrow :(
const SwiperButtonPrev = styled(SwiperButtonNext)`
  left: 22px;
  ${media.laptop`
    left: 3px;
  `};

  right: auto;
  transform: rotate(180deg);
`;

const propTypes = {
  nodes: PropTypes.arrayOf({}).isRequired,
};

class SwipeableCaseStudies extends React.Component {
  componentDidMount() {
    this.drawSwiper();
  }

  drawSwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }

    this.swiper = new Swiper('.swiper-container', {
      loop: true,
      slidesPerView: 2,
      spaceBetween: 32,
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      },
      breakpoints: {
        [sizes.tablet - 1]: {
          slidesPerView: 1,
        },
      },
    });
  }

  render() {
    const { nodes } = this.props;
    return (
      <Wrapper>
        <SwiperButtonPrev className="swiper-button-prev">
          <IconArrowRight />
        </SwiperButtonPrev>
        <SwiperContainer className="swiper-container">
          <div className="swiper-wrapper">
            {mapNodes(nodes).map(caseStudy => (
              <SwipeableCaseStudyWrapper
                key={caseStudy.id}
                className="swiper-slide"
                to={`/work/${caseStudy.slug}`}
              >
                <SwipeableCaseStudy relatedCaseStudy={caseStudy} />
              </SwipeableCaseStudyWrapper>
            ))}
          </div>
        </SwiperContainer>
        <SwiperButtonNext className="swiper-button-next">
          <IconArrowRight />
        </SwiperButtonNext>
      </Wrapper>
    );
  }
}

SwipeableCaseStudies.propTypes = propTypes;

export default SwipeableCaseStudies;



// WEBPACK FOOTER //
// ./src/components/shared/SwipeableCaseStudies/SwipeableCaseStudies.jsx